export const PROFILES = "Profiles"
export const ORGS = "Organizations"
export const STATUS = "Status"
export const AUTOREPLIES = 'AutoReplies'
export const NOTIFY = 'Notify'
export const FORWARD = 'Forward'
export const COMPLETIONEMAILS = 'CompletionEmails'
export const CONVERSATIONS = 'Conversations'